import { Link } from 'react-router-dom';

const DropOffSection = () => (
  <section className="py-14 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4 md:px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">

        {/* Drop-off info */}
        <div className="bg-white border border-gray-200 rounded-xl p-7">
          <h3 className="text-lg font-extrabold text-gray-900 mb-4">E-Waste Drop Off Centers</h3>
          
          <div className="space-y-4 mb-5">
            <div className="bg-gray-50 rounded-lg p-4">
              <p className="text-[#1B6B3A] font-semibold text-sm mb-1">2542 W. 3rd Street, Los Angeles, CA 90057</p>
              <p className="text-gray-400 text-xs flex items-center gap-1">
                <i className="ri-navigation-line"></i>
                Easy access from the 101 & 110 freeways
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-4">
              <p className="text-[#1B6B3A] font-semibold text-sm mb-1">4902 W. Slauson Ave, Los Angeles, CA 90056</p>
              <p className="text-gray-400 text-xs flex items-center gap-1">
                <i className="ri-navigation-line"></i>
                Convenient West LA location
              </p>
            </div>
          </div>

          <h4 className="font-bold text-gray-800 text-sm mb-3">Accepted Items for drop off</h4>
          <div className="grid grid-cols-2 gap-y-1.5 gap-x-4 mb-5">
            {[
              'Computer Recycling', 'Cables/Cords',
              'Televisions', 'Servers',
              'UPS Batteries', 'Network Switches',
              'Cell Phones', 'Printers/Copiers/Fax',
              'Apple Products', 'Hard Drives',
            ].map((item) => (
              <div key={item} className="flex items-center gap-2 text-xs text-gray-600">
                <i className="ri-arrow-right-s-line text-[#1B6B3A]"></i>
                {item}
              </div>
            ))}
          </div>

          <h4 className="font-bold text-gray-800 text-sm mb-2">Items We Cannot Accept</h4>
          <div className="flex flex-wrap gap-x-4 gap-y-1 mb-5">
            {[
              'Microwaves', 'Light Bulbs', 'Single-use alkaline batteries',
              'Monitor (CRT)', 'Printer Ink & Toner', 'Items containing liquid mercury',
              'Hazardous Waste Paint',
            ].map((item) => (
              <div key={item} className="flex items-center gap-1.5 text-xs text-gray-500">
                <i className="ri-close-circle-line text-red-400 text-xs"></i>
                {item}
              </div>
            ))}
          </div>

          <div className="flex items-center gap-2 text-xs text-gray-500 bg-gray-50 rounded-lg px-3 py-2">
            <i className="ri-time-line text-[#1B6B3A]"></i>
            Mon–Fri: 8am–5pm &nbsp;|&nbsp; Sat: 9am–2pm
          </div>
        </div>

        {/* Pickup info */}
        <div className="bg-[#1B6B3A] rounded-xl p-7 text-white">
          <div className="inline-flex items-center gap-1.5 bg-white/20 text-white text-xs font-bold px-2.5 py-1 rounded-full mb-3">
            <i className="ri-truck-line"></i>
            Free Business Pickup
          </div>
          <h3 className="text-lg font-extrabold mb-2">E-Waste Pickup in Los Angeles</h3>
          <p className="text-green-200 text-sm mb-1">
            To Request an E-Waste pickup Click on Request Service or
          </p>
          <p className="text-green-200 text-sm mb-4">
            CALL US AT{' '}
            <a href="tel:+12136001000" className="text-white font-bold hover:underline cursor-pointer">
              (213) 600-1000
            </a>
          </p>

          <div className="text-xs font-bold text-green-300 uppercase tracking-wider mb-2">Areas We Serve</div>
          <div className="grid grid-cols-2 gap-y-1.5 gap-x-4 mb-5">
            {[
              'Downtown Los Angeles', 'Hollywood',
              'Silver Lake & Echo Park', 'Koreatown',
              'Santa Monica & Venice', 'Culver City',
              'Burbank & Glendale', 'San Fernando Valley',
              'Pasadena & SGV', 'South Bay & Harbor',
              'Long Beach', 'Inglewood & Hawthorne',
            ].map((item) => (
              <div key={item} className="flex items-center gap-2 text-xs text-green-100">
                <i className="ri-map-pin-line text-green-300 shrink-0"></i>
                {item}
              </div>
            ))}
          </div>

          <p className="text-green-200 text-xs mb-5">
            We offer e-waste pick-up throughout <strong className="text-white">all of Los Angeles County</strong> and surrounding areas. Not sure if we cover your neighborhood? Just call!
          </p>

          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-white text-[#1B6B3A] font-bold px-5 py-2.5 rounded-md hover:bg-green-50 transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            <i className="ri-arrow-right-circle-line"></i>
            Request Service
          </Link>
        </div>
      </div>

      {/* Get Directions buttons */}
      <div className="mt-5 flex flex-wrap gap-3">
        <a
          href="https://maps.app.goo.gl/1GFb4ZnoPCREHhzy6"
          target="_blank"
          rel="nofollow noreferrer"
          className="inline-flex items-center gap-2 bg-[#1B6B3A] text-white font-semibold px-5 py-2.5 rounded-md hover:bg-[#2D8653] transition-colors cursor-pointer whitespace-nowrap text-sm"
        >
          <i className="ri-map-pin-2-line"></i>
          Get Directions to W 3rd St
        </a>
        <a
          href="https://maps.google.com/?q=4902+W+Slauson+Ave+Los+Angeles+CA+90056"
          target="_blank"
          rel="nofollow noreferrer"
          className="inline-flex items-center gap-2 border border-[#1B6B3A] text-[#1B6B3A] font-semibold px-5 py-2.5 rounded-md hover:bg-[#1B6B3A] hover:text-white transition-colors cursor-pointer whitespace-nowrap text-sm"
        >
          <i className="ri-map-pin-2-line"></i>
          Get Directions to W Slauson Ave
        </a>
      </div>
    </div>
  </section>
);

export default DropOffSection;